import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12b62aea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "item-wrap"
}
const _hoisted_2 = {
  key: 1,
  class: "item-wrap"
}
const _hoisted_3 = { class: "item-wrap" }
const _hoisted_4 = { class: "item-wrap" }

import { onMounted, ref, computed } from 'vue';
import { BaseDialog, BaseTextContent } from 'xrk-components';
import { BaseSvg } from '@/components/base/base-svg/index';
import { maskPhone } from '@/utils/formatter';
import { getContractUserInfo } from '../data-source/apis';


export default /*#__PURE__*/_defineComponent({
  __name: 'company-info-dialog',
  props: {
    id: {},
    type: {},
    partyType: {},
    typeOfPartyAAndPartyB: {},
    contractId: {}
  },
  emits: ['remove'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const info = ref<any>({});
const isIndividual = computed(() => +info.value.type == 3);
const isCompany = computed(() => +info.value.type == 2);

onMounted(() => {
  getContractUserInfo({
    id: props.id,
    type: props.type,
    typeOfPartyAAndPartyB: props.typeOfPartyAAndPartyB,
    contractId: props.contractId
  }).then(res => {
    info.value = res.data;
  });
});

const onCancel = () => {
  emits('remove');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    title: "信息",
    "model-value": true,
    "show-close": true,
    width: "400px",
    "close-on-press-escape": false,
    "close-on-click-modal": false,
    beforeClose: onCancel,
    "cancel-btn-config": {
      show: false
    },
    "before-confirm": onCancel,
    "confirm-btn-config": {
      show: true,
      content: '确定'
    }
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          (isCompany.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(BaseSvg), {
                  class: "icon",
                  iconClass: "gongshi"
                }),
                _createTextVNode(" " + _toDisplayString(info.value.entpName), 1)
              ]))
            : (isIndividual.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_unref(BaseSvg), {
                    class: "icon",
                    iconClass: "getihu"
                  }),
                  _createTextVNode(" " + _toDisplayString(info.value.individualName), 1)
                ]))
              : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(BaseSvg), {
              class: "icon",
              iconClass: "renyuan"
            }),
            _createTextVNode(" " + _toDisplayString(info.value.name), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(BaseSvg), {
              class: "icon",
              iconClass: "shouji"
            }),
            _createTextVNode(" " + _toDisplayString(_unref(maskPhone)(info.value.phone)), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})